import React from 'react';

import { Icon } from '@shared/ui';

const getIcon = ({ type, width, height }) => {
    const iconMapping = {
        tinkoff: <Icon iconName="tinkoff" width={width} height={height} />,
        alfa: <Icon iconName="alfa" width={width} height={height} />,
    };

    return iconMapping[type];
};

export const BankIcon = ({ type, width = 18, height = 16 }) => (
    <>{getIcon({ type, width, height })}</>
);
